module.exports = __webpack_public_path__ + "static/media/excel.3902f7c0.svg";